import { useState } from 'react'
import { useParams, Link } from 'react-router'
import ArrowBack from '@mui/icons-material/ArrowBack'
import { Alert, Stack, Button } from '@mui/material'
import {
  useGetChildDataList,
  useGetDataList,
} from '@/service-library/hooks/data-lists'
import { Organization } from '@/types/organizations'
import Breadcrumb from '@/components/breadcrumbs/Breadcrumb'
import DataListDetails from './DataListDetails'

export default function DataListPage() {
  const { id } = useParams<{ id: string }>()

  const [selectedOrg, setSelectedOrg] = useState<Organization | null>(null)

  const { dataList: parentDataList, queryKey: rootDetailQueryKey } =
    useGetDataList({
      id: id as string,
      filters: {
        fields__include: 'description',
      },
      refetchOnWindowFocus: false,
    })

  const { dataList, isPending, queryKey } = useGetChildDataList({
    orgId: selectedOrg?.id || '',
    id: id as string,
    enabled: !!selectedOrg && !!id,
    filters: {
      fields__include: 'data_list_type',
    },
    refetchOnWindowFocus: false,
  })

  return (
    <Stack sx={{ px: 1, height: '100%' }}>
      {parentDataList && (
        <Breadcrumb label={parentDataList.name} url={`/settings/lists/${id}`} />
      )}

      {!isPending && !parentDataList && (
        <Alert severity="error">
          Unable to load this data list. You may not have access or this data
          list does not exist.
        </Alert>
      )}

      <div>
        <Button
          startIcon={<ArrowBack />}
          component={Link}
          to="../"
          variant="text"
          sx={{ ml: '-4px', mb: 1 }}
        >
          Back to Lists
        </Button>
      </div>
      <DataListDetails
        parentDataList={parentDataList}
        dataList={dataList}
        selectedOrg={selectedOrg}
        setSelectedOrg={setSelectedOrg}
        detailQueryKey={queryKey}
        rootDetailQueryKey={rootDetailQueryKey}
      />
    </Stack>
  )
}
